import { useState, type FormEvent } from "react";
import { Button } from "@dfws/ui";
import { useDeleteFilter, useFilters, useSaveFilter } from "../../lib/queries";
import { ApiFailure } from "../../lib/api";
import { isBlockRule } from "./filterText";
import { Notice } from "./parts";
import s from "./Settings.module.css";

export function BlockedSection() {
  const filters = useFilters();
  const save = useSaveFilter();
  const del = useDeleteFilter();
  const [value, setValue] = useState("");
  const blocked = (filters.data?.items ?? []).filter((f) => isBlockRule(f.criteria, f.actions));

  async function onAdd(e: FormEvent) {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    try {
      await save.mutateAsync({ enabled: true, criteria: { from: v }, actions: { spam: true } });
      setValue("");
    } catch {
      /* shown below */
    }
  }

  return (
    <>
      <p className={s.lead}>Mail from these addresses or domains goes straight to Spam. Use a full address (name@example.com) or a domain (@example.com).</p>
      <form className={s.actionsBar} style={{ marginTop: 0, marginBottom: "var(--space-4)" }} onSubmit={onAdd}>
        <input className={s.input} style={{ maxWidth: 360 }} value={value} onChange={(e) => setValue(e.target.value)} placeholder="name@example.com or @example.com" aria-label="Address or domain to block" />
        <Button type="submit" variant="primary" loading={save.isPending} disabled={!value.trim()}>Block</Button>
      </form>
      {save.error instanceof ApiFailure && <Notice kind="err">{save.error.message}</Notice>}
      {blocked.length === 0 ? (
        <div className={s.empty}>You have not blocked anyone.</div>
      ) : (
        <ul className={s.list}>
          {blocked.map((f) => (
            <li key={f.id} className={s.listItem}>
              <div className={s.listMain}><div className={s.listTitle}>{f.criteria.from}</div></div>
              <Button size="sm" variant="secondary" onClick={() => del.mutate(f.id)}>Unblock</Button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
